Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedDateView extends Backbone.View
  template: JST["backbone/templates/monitoring/filters/date/applied_date"]
  className: 'dates'

  unmodifiableByModerators: true
  dateFormat: 'D MMM YYYY HH:mm'
  fields:
    date_from_realtime: 'date_from_realtime'
    date_from: 'date_from'
    date_from_ISO: 'date_from_ISO'
    date_to: 'date_to'
    date_to_ISO: 'date_to_ISO'
    date_now: 'date_now'

  events:
    "click div.date div.realtime a.remove" : "removeDateFromRealtime"
    "click div.date div.from a.remove" : "removeDateFrom"
    "click div.date div.to a.remove" : "removeDateTo"

  initialize: ({searchQuery}) ->
    @searchQuery = searchQuery
    @title = I18n.t('monitoring.dashboard.filters.filter_names.time.name')

  destroy: ->
    this.remove()
    return false

  render: ->
    @$el.html(@template(@getRenderParameters()))
    @allowClearFilter() unless @unmodifiableByModerators
    return this

  getRenderParameters: ->
    title: @title
    divId: 'date'
    date_from: @dateStrFromISO(@searchQuery.get(@fields['date_from_ISO']))
    date_to: @dateStrFromISO(@searchQuery.get(@fields['date_to_ISO']))
    date_from_realtime: @searchQuery.get(@fields['date_from_realtime'])
    searchQuery: @searchQuery
    removable: false

  dateStrFromISO: (ISODate) ->
    return ISODate unless ISODate
    Date.create(ISODate).format(@dateFormat)

  allowClearFilter: ->
    @$el.find('a.remove, a.remove-filters').attr('style', 'display: inline')
